export default __webpack_public_path__ + "static/media/Login.e4a0f308.svg";